import React, { useCallback, useMemo, useState } from "react";
import type { ComponentType } from "react";
import { useStyles } from "./Calendar.styles";
import { BulkCalendarControlDateRange } from "../../BulkCalendarControl.types";
import { CalendarYear } from "../../../../../../../../../reportng/controls/CalendarYear";
import { CalendarQuarter } from "../../../../../../../../../reportng/controls/CalendarQuarter";
import { CalendarMonth } from "../../../../../../../../../reportng/controls/CalendarMonth";
import { CalendarWeek } from "../../../../../../../../../reportng/controls/CalendarWeek";
import { CalendarDay } from "../../../../../../../../../reportng/controls/CalendarDay";
import type { ICalendarProps } from "./Calendar.types";

export function Calendar<T extends string | number | unknown>(props: ICalendarProps<T>) {
  const classes = useStyles();
  const { dateRange, from, onChangeFrom, to, onChangeTo, disabled, items } = props;
  const fromAs = from as string;
  const toAs = to as string;

  const calendarItems = useMemo(() => (disabled ? [] : items.map((x) => x as any)), [items]);

  let Component: ComponentType<any>;
  switch (dateRange) {
    case BulkCalendarControlDateRange.Annual:
      Component = CalendarYear;
      break;
    case BulkCalendarControlDateRange.Quarter:
      Component = CalendarQuarter;
      break;
    case BulkCalendarControlDateRange.Month:
      Component = CalendarMonth;
      break;
    case BulkCalendarControlDateRange.Week:
      Component = CalendarWeek;
      break;
    case BulkCalendarControlDateRange.Day:
      Component = CalendarDay;
      break;
    default:
      throw new Error("No calendar component set for date range");
  }

  const allYear = dateRange === BulkCalendarControlDateRange.Annual ? true : undefined;
  const labelFrom = "From:";
  const labelTo = "To:";

  const commonProps = {
    allYear,
    disabled,
    items: calendarItems,
    dictionary: "",
  };

  return (
    <div className={classes.root}>
      <Component {...commonProps} label={labelFrom} onChange={onChangeFrom} value={fromAs} />
      <Component {...commonProps} label={labelTo} onChange={onChangeTo} value={toAs} />
    </div>
  );
};
